import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { AuthenticationService } from './services/authentication-service';
import { HelperService } from './services/helper.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(private router: Router,
    private platform: Platform,
    private helper: HelperService,
    public authService: AuthenticationService
    ) {
    this.initializeApp();
  }

  onDashboardPage : boolean = false;

  initializeApp() {
    console.log('initalizeApp')
    this.platform.ready().then(() => {

      console.log('platform ready')

      this.authService.authState.subscribe(state => {
        console.log('authState changed', state)
        this.onDashboardPage = state;

        if (state && this.authService.getCurrentUserEmail()) {
          if (this.authService.getCurrentUserEmail().includes('@socialsportx.net') || this.authService.isEmailVerified) {
            this.router.navigate(['/dashboard'], { replaceUrl: true });
          }
          else {
            this.helper.presentToast('Email is not verified')
            this.authService.signOut();
          }
        } else {
          this.router.navigate(['/login'], { replaceUrl: true });
        }
      });

    });
  }
}
